import React, { useEffect, useState } from "react";
import useMatricula from "../../../hooks/useMatricula";
import "./styles/ModalEditarAutorización.css";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import { templates } from "../../../utils/crearTemplateCombos";
import Select from "../Select/Select";
import { codigoApp, backOffice_programa } from "../../../config/constantes";
import useProcesoMatricula from "../../../hooks/useProcesoMatricula";
import {
  service_api_crud_autorizaciones,
  service_api_listado_autorizacionesSinLoading,
} from "../../../services/Autorizaciones/Autorizaciones";
registerLocale("es", es);

const ModalEditarAutorizacion = ({
  listAsignatura,
  setTableListadoAutorizaciones,
  parametrosLitsTable,
  checkMarcado,
}) => {
  const { obtenerDatosEstudiante, setMsgExitosoTable } = useMatricula();
  const { setLoading, setErrorCursoServices } = useProcesoMatricula();

  const {
    dprograma,
    dperiodo,
    ndocidentidad,
    cinstitucion,
    cperiodo,
    calumno,
  } = obtenerDatosEstudiante || {};

  const {
    cautorizacion,
    ncredito,
    dmotivo,
    gestado,
    dtipo,
    gtipo,
    ccurso,
    fampliacion,
    nsolicitud
  } = checkMarcado || {};

  const [selecionaTipoAutorizacion, setSelecionaTipoAutorizacion] =
    useState("");

  const [fechaAmpliacion, setFechaAmpliacion] = useState("");
  const [motivo, setMotivo] = useState("");
  const maxLength = 500;

  const [numeroCreditos, setNumeroCreditos] = useState("");

  const [listAsignaturaTemplate, setListAsignaturaTemplate] = useState([]);
  const [filteredlistAsignaturaTemplate, setFilteredlistAsignaturaTemplate] =
    useState([]);
  const [selectAsignatura, setSelectAsignatura] = useState([]);

  const [validacionInputs, setValidacionInputs] = useState({
    tipoAutorizacion: false,
    motivo: false,
    ncredito: false,
    fechaAmpliacion: false,
    asignatura: false,
  });
  const handleVerModalSucces = () => {
    if (document.querySelector("#succesTable")) {
      document.querySelector("#succesTable").style.display = "block";
      document.querySelector("#succesTable").classList.add("show");
    }
  };

  useEffect(() => {
    setValidacionInputs({
      tipoAutorizacion: false,
      motivo: false,
      ncredito: false,
      fechaAmpliacion: false,
      asignatura: false,
    });
  }, [checkMarcado]);

  useEffect(() => {
    if (gestado == 1) {
      setSelecionaTipoAutorizacion(gtipo.toString());
      if (ccurso != 0) {
        setSelectAsignatura([ccurso]);
      }
      setMotivo(dmotivo);
      setNumeroCreditos(ncredito);
      if (fampliacion !== null) {
        setFechaAmpliacion(new Date(fampliacion));
      }
    }
  }, [checkMarcado]);

  useEffect(() => {
    setListAsignaturaTemplate(templates("Asigantura", listAsignatura));
    setFilteredlistAsignaturaTemplate(
      templates("Asigantura", listAsignatura, false, 20)
    );
  }, [listAsignatura]);

  useEffect(() => {
    setSelecionaTipoAutorizacion("");
  }, []);

  let handleLimpiar = (borrarTodo = true, borrarUnidad = "") => {
    if (borrarTodo) {
      setSelecionaTipoAutorizacion("");
      setMotivo("");
      setNumeroCreditos("");
      setSelectAsignatura([]);
      setFechaAmpliacion("");
    }
    if (borrarTodo === false) {
      switch (borrarUnidad) {
        case "setSelecionaTipoAutorizacion":
          setSelecionaTipoAutorizacion("");
          break;
        case "setMotivo":
          setMotivo("");
          break;
        case "setNumeroCreditos":
          setNumeroCreditos("");
          break;
        case "setSelectAsignatura":
          setSelectAsignatura([]);
          break;
        case "setFechaAmpliacion":
          setFechaAmpliacion("");
          break;
        default:
          break;
      }
    }
  };

  const soloNumeroDecimal = (e) => {
    let regex = /^[0-9]*(\.[0-9]{0,2})?$/;
    let key = String.fromCharCode(e.charCode ? e.which : e.charCode);
    if (regex.test(key) === true) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  };

  let domColorearInputsValidate = (e) => {
    let objetoEnviar = { ...validacionInputs };
    switch (selecionaTipoAutorizacion) {
      case "":
        if (selecionaTipoAutorizacion == "")

          objetoEnviar = { ...objetoEnviar, tipoAutorizacion: true };
        if (motivo === "" || motivo.length < 5) {
          objetoEnviar = { ...objetoEnviar, motivo: true };
        } else {
          objetoEnviar = { ...objetoEnviar, motivo: false };
        }

        setValidacionInputs({
          ...validacionInputs,
          tipoAutorizacion: objetoEnviar.tipoAutorizacion,
          motivo: objetoEnviar.motivo,
          ncredito: objetoEnviar.ncredito,
          fechaAmpliacion: objetoEnviar.fechaAmpliacion,
          asignatura: objetoEnviar.asignatura,
        });


        break;
      case "1":
        let regex = /^[0-9]*(\.[0-9]{0,2})?$/;
        if (!regex.test(numeroCreditos) || numeroCreditos === "") {
          objetoEnviar = { ...objetoEnviar, ncredito: true };
        } else {
          objetoEnviar = { ...objetoEnviar, ncredito: false };
        }
        if (motivo === "" || motivo.length < 5) {
          objetoEnviar = { ...objetoEnviar, motivo: true };
        } else {
          objetoEnviar = { ...objetoEnviar, motivo: false };
        }
        setValidacionInputs({
          ...validacionInputs,
          tipoAutorizacion: objetoEnviar.tipoAutorizacion,
          motivo: objetoEnviar.motivo,
          ncredito: objetoEnviar.ncredito,
          fechaAmpliacion: objetoEnviar.fechaAmpliacion,
          asignatura: objetoEnviar.asignatura,
        });

        break;
      case "2":
        if (fechaAmpliacion === "" || fechaAmpliacion === null) {
          objetoEnviar = { ...objetoEnviar, fechaAmpliacion: true };
        } else {
          objetoEnviar = { ...objetoEnviar, fechaAmpliacion: false };
        }
        if (motivo === "" || motivo.length < 5) {
          objetoEnviar = { ...objetoEnviar, motivo: true };
        } else {
          objetoEnviar = { ...objetoEnviar, motivo: false };
        }
        setValidacionInputs({
          ...validacionInputs,
          tipoAutorizacion: objetoEnviar.tipoAutorizacion,
          motivo: objetoEnviar.motivo,
          ncredito: objetoEnviar.ncredito,
          fechaAmpliacion: objetoEnviar.fechaAmpliacion,
          asignatura: objetoEnviar.asignatura,
        });

        break;
      case "3":
        if (motivo === "" || motivo.length < 5) {
          objetoEnviar = { ...objetoEnviar, motivo: true };
        } else {
          objetoEnviar = { ...objetoEnviar, motivo: false };
        }
        setValidacionInputs({
          ...validacionInputs,
          tipoAutorizacion: objetoEnviar.tipoAutorizacion,
          motivo: objetoEnviar.motivo,
          ncredito: objetoEnviar.ncredito,
          fechaAmpliacion: objetoEnviar.fechaAmpliacion,
          asignatura: objetoEnviar.asignatura,
        });
        break;
      case "4":
        if (selectAsignatura.length == 0) {
          objetoEnviar = { ...objetoEnviar, asignatura: true };
        } else {
          objetoEnviar = { ...objetoEnviar, asignatura: false };
        }
        if (motivo === "" || motivo.length < 5) {
          objetoEnviar = { ...objetoEnviar, motivo: true };
        } else {
          objetoEnviar = { ...objetoEnviar, motivo: false };
        }
        setValidacionInputs({
          ...validacionInputs,
          tipoAutorizacion: objetoEnviar.tipoAutorizacion,
          motivo: objetoEnviar.motivo,
          ncredito: objetoEnviar.ncredito,
          fechaAmpliacion: objetoEnviar.fechaAmpliacion,
          asignatura: objetoEnviar.asignatura,
        });
        break;
      default:
        break;
    }
  };


  let handleAceptar = async (e) => {
    e.preventDefault();

    if (gestado === 1) {
      let parametros = {
        p_cinstitucion: cinstitucion,
        p_cprograma: backOffice_programa,
        p_cperiodo: cperiodo,
        p_calumno: calumno,
        p_cautorizacion: cautorizacion,
        p_gtipo: selecionaTipoAutorizacion.toString(),
        p_ncredito: numeroCreditos,
        p_fampliacion: fechaAmpliacion,
        p_ccurso: selectAsignatura.toString(),
        p_cbloque: 0,
        p_nnumero2: 0,
        p_gprocesado: 0,
        p_gestado: 1,
        p_dmotivo: motivo,
        p_dobservacion: "",
        p_csolicitud: ndocidentidad,
        p_catencion: ndocidentidad,
        p_caplicacion: codigoApp,
        p_cautoriza: ndocidentidad,
        p_cusuario_sesion: ndocidentidad,
        p_accion: "U",
      };

      domColorearInputsValidate();
      switch (selecionaTipoAutorizacion) {
        case "":
          break;
        case "1":
          let regex = /^[0-9]*(\.[0-9]{0,2})?$/;
          if (!regex.test(numeroCreditos) || numeroCreditos === "") {
            return;
          }
          if (motivo === "" || motivo.length < 5) {
            return;
          }

          try {

            setLoading(true);
            await service_api_crud_autorizaciones(parametros);

            await service_api_listado_autorizacionesSinLoading(
              parametrosLitsTable,
              {
                setList: setTableListadoAutorizaciones,
              }
            );

            document.querySelector("#editarAutorizacion").style.display =
              "none";
            document
              .querySelector("#editarAutorizacion")
              .classList.remove("show");
            handleLimpiar();

            setMsgExitosoTable({
              errors: false,
              msg: "Se ha editado con exito",
            });
            handleVerModalSucces();

          } catch (error) {


            setMsgExitosoTable({ errors: true, msg: error });

            handleVerModalSucces();
          } finally {
            setLoading(false);
          }

          break;
        case "2":
          if (fechaAmpliacion === "" || fechaAmpliacion === null) {
            return;
          }
          if (motivo === "" || motivo.length < 5) {
            return;
          }

          try {

            setLoading(true);

            await service_api_crud_autorizaciones(parametros);

            await service_api_listado_autorizacionesSinLoading(
              parametrosLitsTable,
              {
                setList: setTableListadoAutorizaciones,
              }
            );

            document.querySelector("#editarAutorizacion").style.display =
              "none";
            document
              .querySelector("#editarAutorizacion")
              .classList.remove("show");
            handleLimpiar();
            setMsgExitosoTable({
              errors: false,
              msg: "Se ha editado con exito",
            });
            handleVerModalSucces();
          } catch (error) {
            setMsgExitosoTable({ errors: true, msg: error });

            handleVerModalSucces();
          } finally {
            setLoading(false);
          }

          break;

        case "3":
          if (motivo === "" || motivo.length < 5) {
            return;
          }

          try {

            setLoading(true);
            await service_api_crud_autorizaciones(parametros);

            await service_api_listado_autorizacionesSinLoading(
              parametrosLitsTable,
              {
                setList: setTableListadoAutorizaciones,
              }
            );
            document.querySelector("#editarAutorizacion").style.display =
              "none";
            document
              .querySelector("#editarAutorizacion")
              .classList.remove("show");
            handleLimpiar();

            setMsgExitosoTable({
              errors: false,
              msg: "Se ha guardado con exito",
            });
            handleVerModalSucces();

          } catch (error) {
            setMsgExitosoTable({ errors: true, msg: error });

            handleVerModalSucces();
          } finally {
            setLoading(false);
          }

          break;
        case "4":
          if (selectAsignatura.length == 0) {
            return;
          }
          if (motivo === "" || motivo.length < 5) {
            return;
          }


          try {

            setLoading(true);
            await service_api_crud_autorizaciones(parametros);

            await service_api_listado_autorizacionesSinLoading(
              parametrosLitsTable,
              {
                setList: setTableListadoAutorizaciones,
              }
            );

            document.querySelector("#editarAutorizacion").style.display =
              "none";
            document
              .querySelector("#editarAutorizacion")
              .classList.remove("show");
            handleLimpiar();
            setMsgExitosoTable({
              errors: false,
              msg: "Se ha guardado con exito",
            });
            handleVerModalSucces();

          } catch (error) {


            setMsgExitosoTable({ errors: true, msg: error });

            handleVerModalSucces();
          } finally {
            setLoading(false);
          }

          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    setValidacionInputs({
      tipoAutorizacion: false,
      motivo: false,
      ncredito: false,
      fechaAmpliacion: false,
      asignatura: false,
    });
    switch (selecionaTipoAutorizacion) {
      case "":
        handleLimpiar(false, "setNumeroCreditos");
        handleLimpiar(false, "setFechaAmpliacion");
        handleLimpiar(false, "setSelectAsignatura");
        break;
      case "1":
        handleLimpiar(false, "setFechaAmpliacion");
        handleLimpiar(false, "setSelectAsignatura");
        break;
      case "2":
        handleLimpiar(false, "setNumeroCreditos");
        handleLimpiar(false, "setSelectAsignatura");
        break;
      case "3":
        handleLimpiar(false, "setNumeroCreditos");
        handleLimpiar(false, "setFechaAmpliacion");
        handleLimpiar(false, "setSelectAsignatura");
        break;
      case "4":
        handleLimpiar(false, "setNumeroCreditos");
        handleLimpiar(false, "setFechaAmpliacion");
        break;
      default:
        break;
    }
  }, [selecionaTipoAutorizacion]);


  const maxLengthMotivo = (e) => {

    const inputValue = e.target.value;
    if (inputValue.length > maxLength) {
      e.preventDefault();
      return;
    }

    setMotivo(inputValue);
  }

  return (
    <>
      <div
        className="modal fade"
        id="editarAutorizacion"
        tabIndex={-1}
        aria-labelledby="editarAutorizacionLabel"
        aria-hidden={true}
        data-bs-backdrop="static"
        data-bs-focus={false}
        data-bs-keyboard={false}
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title text-uppercase"
                id="editarAutorizacionLabel"
              >
                Editar autorización
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  setValidacionInputs({
                    tipoAutorizacion: false,
                    motivo: false,
                    ncredito: false,
                    fechaAmpliacion: false,
                    asignatura: false,
                  });
                }}
              />
            </div>
            <div className="modal-body">
              <div className="d-flex mb-2">
                <p className=" fw-medium text-uppercase mb-0"> {dperiodo} </p>
                <span> &nbsp; </span>
                <p className=" fw-medium text-uppercase mb-0"> {dprograma}</p>
              </div>

              <div className="form-group mb-2">
                <label className="fw-medium mb-2">N° de solicitud:</label>
                <input
                  type="text"
                  className="form-control form-control-sm disabled"
                  defaultValue={nsolicitud}
                  disabled
                />
              </div>

              <div className="form-group mb-2">
                <label className="fw-medium mb-2">Tipo:</label>
                <select
                  className={`js-states form-control form-control-sm ${validacionInputs.tipoAutorizacion && "colorrequerido"
                    }`}
                  id="select-nuevoAutorizacion"
                  value={selecionaTipoAutorizacion}
                  disabled
                >
                  <option value={selecionaTipoAutorizacion} title={dtipo}>
                    {dtipo}
                  </option>

                </select>
              </div>

              {selecionaTipoAutorizacion == 1 && (
                <div className="">
                  <div className="form-group mb-2">
                    <label className="fw-medium mb-2">N° de créditos:</label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${validacionInputs.ncredito && "colorrequerido"
                        }`}
                      value={numeroCreditos}
                      onChange={(e) => {
                        setNumeroCreditos(e.target.value);
                      }}
                      onKeyPress={(e) => {
                        return soloNumeroDecimal(e);
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                      }}
                      autoComplete="off"
                    />
                  </div>
                </div>
              )}
              {selecionaTipoAutorizacion == 2 && (
                <div className="">
                  <div className="form-group mb-2">
                    <label className="fw-medium mb-2">Fecha:</label>
                    <div
                      className={`input-group input-group-sm date mb-2 ${validacionInputs.fechaAmpliacion && "colorrequerido"
                        }`}
                      style={{ borderRadius: "0.32rem" }}
                    >
                      <DatePicker
                        selected={fechaAmpliacion}
                        onChange={(date) => setFechaAmpliacion(date)}
                        className="form-control form-control-sm fecha"
                        placeholderText="dd/mm/yyyy"
                        locale="es"
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date()}
                      />
                      <span className="input-group-append">
                        <span className="input-group-text bg-light d-block">
                          <i className="fa fa-calendar"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {selecionaTipoAutorizacion == 4 && (
                <div className="">
                  <div className="form-group mb-2">
                    <label className="fw-medium mb-2">Asignatura</label>

                    <Select
                      option2={filteredlistAsignaturaTemplate}
                      setoption2={setFilteredlistAsignaturaTemplate}
                      option={listAsignaturaTemplate}
                      selection={selectAsignatura || []}
                      setSelection={setSelectAsignatura}
                      colorError={validacionInputs.asignatura}
                    />
                  </div>
                </div>
              )}

              <div className="form-group mb-2">
                <label className="fw-medium mb-2">Motivo:</label>
                <textarea
                  id="motivotext"
                  name="motivotext"
                  className={`form-control form-control-sm ${validacionInputs.motivo && "colorrequerido"
                    }`}
                  rows={4}
                  cols={50}
                  onChange={(e) => {
                    maxLengthMotivo(e);

                  }}
                  value={motivo}
                />
              </div>
            </div>
            <div className="modal-footer text-center">
              <button
                type="button"
                className="btn btn-primary text-center"
                onClick={handleAceptar}
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      ></button>
    </>
  );
};

export default ModalEditarAutorizacion;
